import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-lp-1000 px-3 py-2.5 h-full flex flex-col gap-y-3" }
const _hoisted_2 = { class: "bg-white flex flex-col text-xs overflow-hidden h-full relative w-full px-3 py-2 rounded-lg" }
const _hoisted_3 = { class: "flex flex-row align-middle items-center justify-between w-full mb-4" }
const _hoisted_4 = { class: "mr-4 flex flex-row align-middle justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Search, {
            id: "pusat-resolusi-v2-filter-search",
            value: _ctx.search,
            class: "w-300px mb-1 rounded-md",
            placeholder: _ctx.$t('hubToHub.searchManifestPlaceholder'),
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch
          }, null, 8, ["value", "placeholder", "onInput", "onClear"]),
          _createVNode(_component_time_range_picker, {
            default: _ctx.$t('hubToHub.last30Days'),
            startDate: _ctx.startDate,
            endDate: _ctx.endDate,
            maxDate: new Date(),
            onSelect: _ctx.setDateRange
          }, null, 8, ["default", "startDate", "endDate", "maxDate", "onSelect"])
        ]),
        _createVNode(_component_lp_button, {
          title: _ctx.$t('hubToHub.updateInHub'),
          "data-testid": "hub-to-hub-button-update-in-hub",
          textColor: "white",
          onClick: () => _ctx.$router.push('/hub-to-hub/update-in-hub')
        }, null, 8, ["title", "onClick"])
      ]),
      _createVNode(_component_TableV2, {
        "data-testid": "hub-to-hub-in-hub-table",
        columns: _ctx.columns,
        data: _ctx.inHubManifestList,
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
        loading: _ctx.isLoading,
        paginationStyle: "v3",
        bgHeader: "bg-white border-b border-t",
        isSpaceTop: false,
        borderBottom: false,
        borderTop: false,
        onRequest: _ctx.getListInHub,
        pinnedSubstractHeight: "280px",
        isNoPaddingBottom: "",
        customClassPagination: "absolute w-full bottom-7 pr-10",
        paginationV3PaddingVertical: "pb-4 pt-5"
      }, null, 8, ["columns", "data", "pagination", "loading", "onRequest"])
    ])
  ]))
}